module.exports = __webpack_public_path__ + "img/user-avatar.1990ef3f.svg";